import { render, staticRenderFns } from "./StationPlaceEditor.vue?vue&type=template&id=ee5ce4ec&scoped=true&"
import script from "./StationPlaceEditor.vue?vue&type=script&lang=js&"
export * from "./StationPlaceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5ce4ec",
  null
  
)

/* custom blocks */
import block0 from "./StationPlaceEditor.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee5ce4ec')) {
      api.createRecord('ee5ce4ec', component.options)
    } else {
      api.reload('ee5ce4ec', component.options)
    }
    module.hot.accept("./StationPlaceEditor.vue?vue&type=template&id=ee5ce4ec&scoped=true&", function () {
      api.rerender('ee5ce4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaces/StationPlaceEditor.vue"
export default component.exports